import { useTranslation } from '../../../../../utils/useTranslation';
import { Button } from '../../../../input/Button';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { AdvertisingMoreButtonProps } from './types';

export const AdvertisingMoreButton: React.FC<AdvertisingMoreButtonProps> = ({ onClick }) => {
    const t = useTranslation();

    return (
        <Button size="m" color="secondary" width="100%" onClick={onClick}>
            <Flex direction="row" alignItems="center" spacing={0.5}>
                <Typography variant="caption" weight="bold" color="primary">
                    {t('Выбрать')}
                </Typography>
            </Flex>
        </Button>
    );
};
